import React, { Component } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../config';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import Breadcrumb from '../../components/breadcrumb';
import Emag from '../../components/emag';
import File from '../../components/file';
import SpinnerDots from '../../components/spinner/dots';
import './publication.scss';

class Publication extends Component {

    state = {
        isLoading: true,
        publication: null,
        message: null
    }
    
    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;
        if (this.state.publication) return;
        if (this.state.message) return;

        const { match } = this.props;
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/publication/${match.params.id}`);
        
        if (res.ok) {
            const publication = await res.json();
            this.setState({
                isLoading: false,
                publication
            });
        } else {
            this.setState({
                isLoading: false,
                message: '🔦 Vi kunde inte hitta någon publikation.'
            });
        }
    
    }

    render() {
        return (
            <section className={classNames({
                'publication': true,
                'publication--is-loading': this.state.isLoading
            })}>
                <Breadcrumb url="/publications" link_text="Tillbaka" />
                <div className="publication__inner">
                    {this.state.publication &&
                        <div className={classNames({
                            'publication__wrapper': true,
                            'publication__wrapper--no-access': (this.state.publication && this.state.publication.files.length === 0 && !this.state.publication.userHasAccessToThisPublication)
                        })}>
                            {(this.state.publication && this.state.publication.files.length === 0 && !this.state.publication.userHasAccessToThisPublication) &&
                                <div className="publication__no-access">
                                    {(this.state.publication.images && this.state.publication.images.length > 0) &&
                                        <div className="publication__no-access-img">
                                            <div className="publication__no-access-img-ratio">
                                                <img src={this.state.publication.images[0].filePath} alt="" />
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            <div>
                                <h1>{this.state.publication.title}</h1>
                                <div className="publication__preamble" dangerouslySetInnerHTML={{__html: this.state.publication.description }}></div>
                                {(this.state.publication && this.state.publication.userHasAccessToThisPublication) &&
                                    <>
                                        {this.state.publication.linkToPublication &&
                                            <Emag title={this.state.publication.title} src={this.state.publication.linkToPublication} />
                                        }
                                    </>
                                }

                                {(this.state.publication && this.state.publication.files.length === 0 && !this.state.publication.userHasAccessToThisPublication) &&
                                    <a className="button publication__order" href="https://www.delfi.se/publications">Beställ publikation här</a>
                                }
                            </div>

                            {(this.state.publication && this.state.publication.files && this.state.publication.files.length > 0) &&
                                <File thumbnail={this.props.thumbnail} {...this.state} fetch={this.props.fetch} />
                            }
                        </div>
                    }                    
                </div>
                <SpinnerDots />
            </section>
        );
    }
};

export default withAuthProvider(withFetch(withRouter(Publication)));